import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData } from '@/auth/utils'

import dashboard from './routes/dashboard'
import pages from './routes/pages'
import conversions from './routes/conversions'
import phone from './routes/phone'
import settings from './routes/settings'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'landing' } },
    ...dashboard,
    ...pages,
    ...conversions,
    ...phone,
    ...settings,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  const userData = getUserData()

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect to verify if logged in but not verified
  if (to.meta.redirectIfLoggedIn && isLoggedIn && !userData.email_verified) {
    return next({ name: 'auth-verify-account' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn && userData.email_verified) {
    next('/')
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
// router.afterEach(() => {
//   // Remove initial loading
//   const appLoading = document.getElementById('loading-bg')
//   if (appLoading) {
//     appLoading.style.display = 'none'
//   }
// })

export default router
